module.exports = __webpack_public_path__ + "img/ctrl-ising-stub-up-0.598ce010.svg";